// src/PreAnaestheticForm.js
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from '../../lib/constants';
import {
  Container,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Paper,
  Divider,
  Button,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControl,
  RadioGroup,
  Radio,
  Autocomplete,
  IconButton,
  Box,
  InputLabel,
  ListSubheader,
  Select,
  FormHelperText
} from "@mui/material";
import SignatureCanvas from "react-signature-canvas";
import { useParams, useNavigate } from "react-router-dom";
import ShareIcon from '@mui/icons-material/Share';
import LocalHospital from '@mui/icons-material/LocalHospital';

import theme from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, loadDraft, clearDraft } from '../../utils/draftUtils';
const PreAnaestheticForm = () => {
  const { showNotification } = useNotification();
  const uhid_no = useParams().uhid_no;
  const [formData, setFormData] = useState({
    ip_no: "",
    uhid_no: uhid_no || "",
    name: "",
    age: "",
    sex: "",
    op_no: "",
    pre_op_diagnosis: "",
    proposed_procedure: "",
    proposed_date_time: "",
    cvs_chest_pain: "",
    cvs_breathlessness: "",
    cvs_palpitation: "",
    cvs_hypertension: "",
    cvs_ihd: "",
    cvs_others: "",
    rs_fever: "",
    rs_cough_sputum: "",
    rs_asthma: "",
    rs_copd: "",
    rs_pul_tb: "",
    rs_sneezing: "",
    rs_others: "",
    git_apd: "",
    git_jaundice: "",
    git_others: "",
    gns_stroke: "",
    gns_seizures: "",
    gns_polio: "",
    gns_loc: "",
    gns_head_injury: "",
    spine: "",
    endocrine_dm: "",
    endocrine_thyroid: "",
    endocrine_others: "",
    gu_system_burns: "",
    gu_system_others: "",
    past_or_current_medications: "",
    previous_hospitalization: "",
    previous_surgery_anesthesia: "",
    drug_allergy: "",
    smoking: "",
    substance_abuse: "",
    alcoholism: "",
    pregnancy_lactation: "",
    breath_holding_time: "",
    effort_tolerance: "",
    personal_history_others: "",
    mpc: "",
    mo: "",
    neck_movement: "",
    mento_hyoid_distance: "",
    dentition: "",
    airway_assessment_others: "",
    pr: "",
    bp: "",
    spo2: "",
    temp: "",
    ht: "",
    wt: "",
    riskfactors_concerns: "",
    conscious: "",
    oriented: "",
    pallor: "",
    febrile: "",
    icterus: "",
    cyanosis: "",
    clubbing: "",
    oedema: '',
    cvs: "",
    rs: "",
    git: "",
    gns: "",
    spine_evaluation: "",
    others_evaluation: "",
    experts_opinion: "",
    hb: "",
    pcv: "",
    tc: "",
    dc: "",
    esr: "",
    platelets: "",
    bt: "",
    ct: "",
    pt: "",
    inr: "",
    aptt: "",
    blood_sugar: "",
    random_bs: "",
    fbs: "",
    ppbs: "",
    urea: "",
    creatinine: "",
    electrolytes: "",
    na: "",
    k: "",
    cl: "",
    hco3: "",
    blood_group_rh: "",
    cxr: "",
    ecg: "",
    echo: '',
    lft: '',
    tft: '',
    hiv: '',
    hbsag: "",
    vdrl: "",
    other_investigations: '',
    asa_grade: "",
    plan_of_anesthesia: "",
    pre_op_instructions: "",
    day_of_surgery_medications: "",
    blood_sugar_random: "",
    blood_sugar_fbs: "",
    blood_sugar_ppbs: "",
    blood_sugar_urea: "",
    blood_sugar_creatinine: "",
    blood_sugar_electrolytes: "",
    instructions: "",
    informed_consent: "",
    npo_orders: "",
    blood_products: "",
    investigations: "",
    re_assessment: "",
    expert_opinion: "",
    anaesthesiologist_signature: "",
    anaesthesiologist_name: "",
    anaesthesiologist_date: "",
    anaesthesiologist_time: "",
    surgeon_signature: "",
    surgeon_name: "",
    surgeon_date: "",
    surgeon_time: "",
    nurse_signature: "",
    nurse_name: "",
    nurse_date: "",
    nurse_time: ""
  });
  // Removed duplicate declaration of signatureDialogOpen


  const navigate = useNavigate();
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case 'pre_op_diagnosis':
        if (!value || !value.trim()) error = "Diagnosis is required";
        break;
      case 'proposed_procedure':
        if (!value || !value.trim()) error = "Procedure is required";
        break;
      case 'proposed_date_time':
        if (!value) error = "Date & Time is required";
        break;
      case 'anaesthesiologist_name':
        if (!value) error = "Anaesthetist name is required";
        break;
      case 'surgeon_name':
        if (!value) error = "Surgeon name is required";
        break;
      case 'nurse_name':
        if (!value) error = "Nurse name is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  };

  const validate = () => {
    const requiredFields = [
      { key: 'pre_op_diagnosis', label: 'Pre-Op Diagnosis' },
      { key: 'proposed_procedure', label: 'Proposed Procedure' },
      { key: 'proposed_date_time', label: 'Proposed Date & Time' },
      { key: 'anaesthesiologist_name', label: 'Anaesthetist Name' },
      { key: 'surgeon_name', label: 'Surgeon Name' },
      { key: 'nurse_name', label: 'Nurse Name' },
    ];
    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '')
        tempErrors[key] = `${label} is required`;
    });
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus(); }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }
    return Object.keys(tempErrors).length === 0;
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    validateField(name, value);
  };

  const handleChange = (field) => (event, newValue) => {
    // For Autocomplete, newValue is the selected value or typed input.
    // For TextField, event.target.value works.
    let value;
    if (event && event.target) {
      value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    } else {
      // For Autocomplete input change, event is null, newValue contains the new input value.
      value = newValue;
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }));
    }
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const fields = [
    {
      name: [
        "Hb", "PCV", "TC", "DC", "ESR", "Plastists", "BT", "CT", "PT", "INR", "aPTT",
        "Blood Sugar - Random", "Blood Sugar - FBS", "Blood Sugar - PPBS", "Blood Sugar - Urea", "Blood Sugar - Creatinine",
        "Blood Sugar - Electrolytes", "Na+", "K+", "CL-", "HCO-3",
        "Blood Group/Rh", "CXR", "ECG", "ECHO", "LFT", "TFT",
        "HIV", "HbeAg", "VDRL"
      ],
      key1: [
        'hb', 'pcv', 'tc', 'dc', 'esr', 'platelets', 'bt', 'ct', 'pt', 'inr', 'aptt',
        'blood_sugar_random', 'blood_sugar_fbs', 'blood_sugar_ppbs', 'blood_sugar_urea',
        'blood_sugar_creatinine', 'blood_sugar_electrolytes', 'na', 'k', 'cl', 'hco3',
        'blood_group_rh', 'cxr', 'ecg', 'echo', 'lft', 'tft', 'hiv', 'hbsag', 'vdrl'
      ]
    }
  ];
  const investigationOptions = {
    hb: ['Normal', 'Low', 'High'],
    pcv: ['Normal', 'Low', 'High'],
    tc: ['Normal', 'Low', 'High'],
    dc: ['Normal', 'Low', 'High'],
    esr: ['Normal', 'Elevated'],
    platelets: ['Normal', 'Low', 'High'],
    bt: ['Normal', 'Abnormal'],
    ct: ['Normal', 'Abnormal'],
    pt: ['Normal', 'Abnormal'],
    inr: ['Normal', 'Abnormal'],
    aptt: ['Normal', 'Abnormal'],
    blood_sugar_random: ['Normal', 'Elevated', 'Low'],
    blood_sugar_fbs: ['Normal', 'Elevated', 'Low'],
    blood_sugar_ppbs: ['Normal', 'Elevated', 'Low'],
    blood_sugar_urea: ['Normal', 'Elevated', 'Low'],
    blood_sugar_creatinine: ['Normal', 'Elevated', 'Low'],
    blood_sugar_electrolytes: ['Normal', 'Abnormal'],
    na: ['Normal', 'Low', 'High'],
    k: ['Normal', 'Low', 'High'],
    cl: ['Normal', 'Low', 'High'],
    hco3: ['Normal', 'Low', 'High'],
    blood_group_rh: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
    cxr: ['Normal', 'Abnormal'],
    ecg: ['Normal', 'Abnormal'],
    echo: ['Normal', 'Abnormal'],
    lft: ['Normal', 'Abnormal'],
    tft: ['Normal', 'Abnormal'],
    hiv: ['Positive', 'Negative'],
    hbsag: ['Positive', 'Negative'],
    vdrl: ['Positive', 'Negative'],
  };
  // Replace your handleSubmit function with this fixed version

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;
    console.log("Submitting Data:", formData);

    // Helper function to clean base64 strings
    const cleanBase64 = (base64String) => {
      if (!base64String) return '';
      // Remove data URL prefix if present
      if (base64String.includes(',')) {
        return base64String.split(',')[1];
      }
      return base64String;
    };

    // Helper function to format date for backend
    const formatDate = (dateValue) => {
      if (!dateValue) return null;
      try {
        // If it's already an ISO string, return it
        if (typeof dateValue === 'string' && dateValue.includes('T')) {
          return dateValue;
        }
        // Otherwise, create a Date object and convert to ISO
        const date = new Date(dateValue);
        return date.toISOString();
      } catch (error) {
        console.error('Error formatting date:', error);
        return null;
      }
    };

    // Helper function to format time (HH:MM:SS format)
    const formatTime = (timeValue) => {
      if (!timeValue) return null;
      try {
        // If it contains 'T', extract time part from ISO string
        if (typeof timeValue === 'string' && timeValue.includes('T')) {
          const date = new Date(timeValue);
          return date.toTimeString().split(' ')[0]; // Returns HH:MM:SS
        }
        // If it's already in HH:MM format, add seconds
        if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
          return `${timeValue}:00`;
        }
        // If it's in HH:MM:SS format, return as is
        if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}:\d{2}$/)) {
          return timeValue;
        }
        return timeValue;
      } catch (error) {
        console.error('Error formatting time:', error);
        return null;
      }
    };

    const data = {
      ip_no: formData.ip_no,
      hospital_id: 1,
      uhid_no: formData.uhid_no,
      name: formData.name,
      age: formData.age,
      sex: formData.sex,
      op_no: formData.op_no,
      pre_op_diagnosis: formData.pre_op_diagnosis || '',
      proposed_procedure: formData.proposed_procedure || '',
      proposed_date_time: formatDate(formData.proposed_date_time),

      // CVS fields
      cvs_others: formData.cvs_others || '',
      cvs_chest_pain: formData.cvs_chest_pain || null,
      cvs_breathlessness: formData.cvs_breathlessness || null,
      cvs_palpitation: formData.cvs_palpitation || null,
      cvs_hypertension: formData.cvs_hypertension || null,
      cvs_ihd: formData.cvs_ihd || null,

      // RS fields
      rs_fever: formData.rs_fever || null,
      rs_cough_sputum: formData.rs_cough_sputum || null,
      rs_asthma: formData.rs_asthma || null,
      rs_copd: formData.rs_copd || null,
      rs_pul_tb: formData.rs_pul_tb || null,
      rs_sneezing: formData.rs_sneezing || null,
      rs_others: formData.rs_others || '',

      // GIT fields
      git_apd: formData.git_apd || null,
      git_jaundice: formData.git_jaundice || null,
      git_others: formData.git_others || '',

      // GNS fields
      gns_stroke: formData.gns_stroke || null,
      gns_seizures: formData.gns_seizures || null,
      gns_polio: formData.gns_polio || null,
      gns_loc: formData.gns_loc || null,
      gns_head_injury: formData.gns_head_injury || null,
      spine: formData.spine || '',

      // Endocrine fields
      endocrine_dm: formData.endocrine_dm || null,
      endocrine_thyroid: formData.endocrine_thyroid || null,
      endocrine_others: formData.endocrine_others || '',

      // GU System
      gu_system_burns: formData.gu_system_burns || null,
      gu_system_others: formData.gu_system_others || '',

      // History fields
      past_or_current_medications: formData.past_or_current_medications || '',
      previous_hospitalization: formData.previous_hospitalization || false,
      previous_surgery_anesthesia: formData.previous_surgery_anesthesia || false,
      drug_allergy: formData.drug_allergy || false,
      smoking: formData.smoking || false,
      substance_abuse: formData.substance_abuse || false,
      alcoholism: formData.alcoholism || false,
      pregnancy_lactation: formData.pregnancy_lactation || false,

      // Personal history
      breath_holding_time: formatTime(formData.breath_holding_time),
      effort_tolerance: formData.effort_tolerance || '',
      personal_history_others: formData.personal_history_others || '',

      // Airway assessment
      mpc: formData.mpc || null,
      mo: formData.mo || null,
      neck_movement: formData.neck_movement || null,
      mento_hyoid_distance: formData.mento_hyoid_distance || null,
      dentition: formData.dentition || '',
      airway_assessment_others: formData.airway_assessment_others || '',

      // Vital signs
      pr: formData.pr || null,
      bp: formData.bp || null,
      spo2: formData.spo2 || null,
      temp: formData.temp || null,
      ht: formData.ht || null,
      wt: formData.wt || null,
      riskfactors_concerns: formData.riskfactors_concerns || '',

      // General examination
      conscious: formData.conscious || false,
      oriented: formData.oriented || false,
      pallor: formData.pallor || false,
      febrile: formData.febrile || false,
      icterus: formData.icterus || false,
      cyanosis: formData.cyanosis || false,
      clubbing: formData.clubbing || false,
      oedema: formData.oedema || false,
      general_examination_others: formData.general_examination_others || '',

      // System examination
      expert_opinion: formData.expert_opinion || '',
      cvs: formData.cvs || '',
      rs: formData.rs || '',
      git: formData.git || '',
      gns: formData.gns || '',
      spine_evaluation: formData.spine_evaluation || '',
      others_evaluation: formData.others_evaluation || '',
      experts_opinion: formData.experts_opinion || '',

      // Investigations
      hb: formData.hb || null,
      pcv: formData.pcv || null,
      tc: formData.tc || null,
      dc: formData.dc || null,
      esr: formData.esr || null,
      platelets: formData.platelets || null,
      bt: formData.bt || null,
      ct: formData.ct || null,
      pt: formData.pt || null,
      inr: formData.inr || null,
      aptt: formData.aptt || null,
      blood_sugar: formData.blood_sugar || null,
      random_bs: formData.random_bs || null,
      fbs: formData.fbs || null,
      ppbs: formData.ppbs || null,
      urea: formData.urea || null,
      creatinine: formData.creatinine || null,
      electrolytes: formData.electrolytes || null,
      na: formData.na || null,
      k: formData.k || null,
      cl: formData.cl || null,
      hco3: formData.hco3 || null,
      blood_group_rh: formData.blood_group_rh || null,
      blood_sugar_random: formData.blood_sugar_random || null,
      blood_sugar_fbs: formData.blood_sugar_fbs || null,
      blood_sugar_ppbs: formData.blood_sugar_ppbs || null,
      blood_sugar_urea: formData.blood_sugar_urea || null,
      blood_sugar_creatinine: formData.blood_sugar_creatinine || null,
      blood_sugar_electrolytes: formData.blood_sugar_electrolytes || null,
      others: formData.others || '',
      cxr: formData.cxr || null,
      ecg: formData.ecg || null,
      echo: formData.echo || null,
      lft: formData.lft || null,
      tft: formData.tft || null,
      hiv: formData.hiv || null,
      hbsag: formData.hbsag || null,
      vdrl: formData.vdrl || null,
      other_investigations: formData.other_investigations || '',

      // Anaesthesia plan
      asa_grade: formData.asa_grade || null,
      plan_of_anesthesia: formData.plan_of_anesthesia || '',
      pre_op_instructions: formData.pre_op_instructions || '',
      day_of_surgery_medications: formData.day_of_surgery_medications || '',
      instructions: formData.instructions || '',
      informed_consent: formData.informed_consent || null,
      npo_orders: formData.npo_orders || '',
      blood_products: formData.blood_products || null,
      investigations: formData.investigations || '',
      re_assessment: formData.re_assessment || '',

      // Signatures - Clean base64 strings before sending
      anaesthesiologist_signature: cleanBase64(formData.anaesthesiologist_signature),
      anaesthesiologist_name: formData.anaesthesiologist_name || '',
      anaesthesiologist_date: formatDate(formData.anaesthesiologist_date),
      anaesthesiologist_time: formatTime(formData.anaesthesiologist_time),

      surgeon_signature: cleanBase64(formData.surgeon_signature),
      surgeon_name: formData.surgeon_name || '',
      surgeon_date: formatDate(formData.surgeon_date),
      surgeon_time: formatTime(formData.surgeon_time),

      nurse_signature: cleanBase64(formData.nurse_signature),
      nurse_name: formData.nurse_name || '',
      nurse_date: formatDate(formData.nurse_date),
      nurse_time: formatTime(formData.nurse_time)
    };

    try {
      if (success === "success") {
        const responseUpdate = await axios.put(
          `${API_BASE_URL}/update_pre_anaesthetic/${uhid_no}`,
          data
        );
        showNotification('success', 'Pre-Anaesthetic Evaluation updated successfully!');
      } else {
        const response = await axios.post(
          `${API_BASE_URL}/submit_pre_anaesthetic`,
          data
        );
        console.log('preAnaestheticform Response: ', response.data);
        showNotification('success', 'Pre-Anaesthetic Evaluation submitted successfully!');
      }

      clearSavedData();
      navigate(`/mainPage/${formData.uhid_no}`, {
        state: { from: 'PreOperativePhase', status: 'success', step: 1 },
      });
    } catch (error) {
      console.error('There was an error submitting the form!', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        showNotification('error', `Error: ${error.response.data.error || 'Failed to submit form'}`);
      } else {
        showNotification('error', 'Error in submitting Pre-Anaesthetic Evaluation form!');
      }
    }
  };
  const [next, setNext] = useState('');

  const illnessMapping = {
    cvs: [
      { name: "Chest Pain", key: "cvs_chest_pain" },
      { name: "Breathlessness", key: "cvs_breathlessness" },
      { name: "Palpitation", key: "cvs_palpitation" },
      { name: "Hypertension", key: "cvs_hypertension" },
      { name: "IHD", key: "cvs_ihd" },
    ],
    rs: [
      { name: "Fever", key: "rs_fever" },
      { name: "Cough & Sputum", key: "rs_cough_sputum" },
      { name: "Asthma", key: "rs_asthma" },
      { name: "COPD", key: "rs_copd" },
      { name: "Pul TB", key: "rs_pul_tb" },
      { name: "Sneezing", key: "rs_sneezing" },
    ],
    git: [
      { name: "APD", key: "git_apd" },
      { name: "Jaundice", key: "git_jaundice" },
    ],
    gns: [
      { name: "Stroke", key: "gns_stroke" },
      { name: "Seizures", key: "gns_seizures" },
      { name: "Pollo", key: "gns_polio" },
      { name: "LOC", key: "gns_loc" },
      { name: "Head Injury", key: "gns_head_injury" },
    ],
  };
  const spineOptions = [
    "Normal",
    "Abnormal",
    "Degenerative",
    "Fractured",
    "Other"
  ];
  const reAssessmentOptions = [
    "Stable",
    "Requires monitoring",
    "Urgent intervention needed",
    "Improving",
    "Declining",
  ];

  const investigationsOptions = [
    "CBC",
    "X-Ray Chest",
    "ECG",
    "Blood Sugar",
    "LFT",
    "Electrolytes",
    "Urine Analysis",
  ];
  const npoOrdersOptions = [
    "No food 8 hours prior",
    "No fluids 4 hours prior",
    "Clear liquids allowed",
    "No chewing gum",
    "No smoking",
  ];
  const instructionsOptions = [
    "Take medications as prescribed",
    "Avoid heavy meals before surgery",
    "Follow fasting guidelines",
    "Bring previous medical reports",
    "Arrange for post-op transport",
  ];
  const preOpInstructionsOptions = [
    "Nil per oral after midnight",
    "No blood thinners for 5 days",
    "Take morning medications with a sip of water",
    "Arrive 2 hours before surgery",
    "Avoid smoking for 24 hours",
  ];
  const planOptions = [
    "General Anesthesia",
    "Regional Anesthesia",
    "Local Anesthesia",
    "Sedation",
    "Spinal Anesthesia",
    "Epidural Anesthesia",
  ];
  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);

      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        name: response.data.name,
        age: response.data.age || "",
        sex: response.data.sex || "",

      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setError('Failed to fetch patient data. Please try again.');
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([

          axios.get(`${API_BASE_URL}/pre_anaesthetic_next_ip`)
        ]);
        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip_no
        }));
      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);
  const riskFactorOptions = [
    "Diabetes",
    "Hypertension",
    "Smoking",
    "Allergy",
    "Previous Surgery",
    "Cardiac issues",
    "Respiratory issues",
    // add more common risk factors here
  ];
  const effortToleranceOptions = [
    "Low",
    "Moderate",
    "High",
    "Very High"
  ];
  const dentitionOptions = [
    "Normal",
    "Missing Teeth",
    "Caries",
    "Partial Denture",
    "Full Denture"
  ];
  const options = {
    pr: ["60", "70", "80", "90", "100"],       // example pulse rates
    bp: ["110/70", "120/80", "130/85", "140/90"], // example blood pressures
    spo2: ["95", "96", "97", "98", "99", "100"],
    temp: ["97", "98", "99", "100", "101", "102"],
    ht: ["150", "155", "160", "165", "170", "175"],
    wt: ["50", "55", "60", "65", "70", "75"]
  };
  const cvsOptions = ["Normal", "Murmur", "Tachycardia", "Bradycardia"];
  const rsOptions = ["Clear", "Wheezing", "Crackles", "Decreased breath sounds"];
  const gitOptions = ["Normal", "Tenderness", "Distension", "Mass"];
  const gnsOptions = ["Alert", "Confused", "Drowsy", "Unconscious"];

  const expertOpinionOptions = ["Agree", "Disagree", "Needs further tests"];
  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState("");
  const signaturePadRef = useRef(null);
  const handleSignatureOpen = (signatureKey) => {
    const signatureMeta = {
      anaesthesiologist_signature: {
        dateKey: "anaesthesiologist_date",
        timeKey: "anaesthesiologist_time"
      },
      surgeon_signature: {
        dateKey: "surgeon_date",
        timeKey: "surgeon_time"
      },
      nurse_signature: {
        dateKey: "nurse_date",
        timeKey: "nurse_time"
      }
    };

    const now = new Date();
    const isoDate = now.toISOString().slice(0, 10); // YYYY-MM-DD
    const isoTime = now.toTimeString().slice(0, 5); // HH:MM

    if (signatureMeta[signatureKey]) {
      const { dateKey, timeKey } = signatureMeta[signatureKey];

      setFormData((prev) => ({
        ...prev,
        [dateKey]: isoDate,
        [timeKey]: isoTime,
      }));
    }

    setCurrentSignatureRole(signatureKey);
    setSignatureDialogOpen(true);
  };

  const handleSignatureClose = () => {
    setSignatureDialogOpen(false)
  }

  const handleSignatureClear = () => {
    signaturePadRef.current.clear();
  };

  const handleSignatureSave = () => {
    const dataURL = signaturePadRef.current.toDataURL();
    setFormData((prevData) => ({
      ...prevData,
      [currentSignatureRole]: dataURL.split(',')[1],
    }));
    setSignatureDialogOpen(false);
  };


  useEffect(() => {
    axios.get(`${API_BASE_URL}/get_pre_anaesthetic/${uhid_no}`)
      .then((response) => {
        console.log('Fetched data:', response.data);

        const dateFields = [
          "proposed_date_time",
          "anaesthesiologist_date",
          "nurse_date",

          "surgeon_date",
        ];

        const timeFields = [
          "breath_holding_time",
          "nurse_time",
          "surgeon_time",
          "anaesthesiologist_time",
        ];


        // Format each date field for 'type="date"' input
        const formattedData = dateFields.reduce((acc, field) => {
          if (response.data[field]) {
            acc[field] = new Date(response.data[field]).toISOString().slice(0, 10); // YYYY-MM-DD
          }
          return acc;
        }, {});

        // Format each date field and update the formData
        /*   const formattedData = dateFields.reduce((acc, field) => {
            if (response.data[field]) {
              acc[field] = new Date(response.data[field]).toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm
            }
            return acc;
          }, {}); */

        // Format time fields to HH:mm (or HH:mm:ss if needed)
        const formattedTimes = timeFields.reduce((acc, field) => {
          if (response.data[field]) {
            const [hours, minutes] = response.data[field].split(':');
            acc[field] = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`; // HH:mm format
          }
          return acc;
        }, {});

        // Convert all signatures to base64
        const signatureFields = [
          "anaesthesiologist_signature",
          "nurse_signature",
          "surgeon_signature",
        ];
        const formattedProposedDateTime = {};
        if (response.data.proposed_date_time) {
          const parsedDate = new Date(response.data.proposed_date_time);
          if (!isNaN(parsedDate)) {
            formattedProposedDateTime.proposed_date_time = parsedDate.toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm
          }
        }
        setFormData({
          ...response.data,
          ...formattedData,
          ...formattedTimes,
          ...formattedProposedDateTime,

          ...signatureFields.reduce((acc, field) => {
            if (response.data[field]) {
              acc[field] = response.data[field];
            }
            return acc;
          }, {}),
        });

        setSuccess("success");
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
    fetchPatientData(uhid_no);
  }, [uhid_no]);

  // Load draft on mount
  useEffect(() => {
    const draft = loadDraft(DRAFT_KEYS.PRE_ANAESTHETIC_FORM, uhid_no);
    if (draft && draft.formData) {
      setFormData(prev => ({ ...prev, ...draft.formData }));
    }
  }, [uhid_no]);

  const opOptions = [1001, 1002, 1003, 1004, 1005];
  const diagnosisOptions = [
    "Appendicitis",
    "Cholecystitis",
    "Hernia",
    "Fracture",
    "Other"
  ];

  const procedureOptions = [
    "Appendectomy",
    "Cholecystectomy",
    "Hernia Repair",
    "Fracture Fixation",
    "Other"
  ];
  const nurseGroups = {
    ICU: [
      "Nurse Anna Smith",
      "Nurse Brian Lee",
      "Nurse Carol White",
      "Nurse David Green",
      "Nurse Emma Black",
      "Nurse Frank Harris",
    ],
    Pediatrics: [
      "Nurse Emily Davis",
      "Nurse Frank Miller",
      "Nurse Grace Wilson",
      "Nurse Hannah Moore",
      "Nurse Ian Clark",
      "Nurse Julia Lewis",
    ],
    GeneralWard: [
      "Nurse Henry Brown",
      "Nurse Irene Clark",
      "Nurse Jack Harris",
      "Nurse Kelly Martinez",
      "Nurse Liam Thompson",
      "Nurse Mia Anderson",
    ],
    Emergency: [
      "Nurse Karen Scott",
      "Nurse Larry Adams",
      "Nurse Monica Turner",
      "Nurse Nathan Hill",
      "Nurse Olivia King",
      "Nurse Peter Wright",
    ],
    Surgery: [
      "Nurse Quinn Young",
      "Nurse Rachel Walker",
      "Nurse Samuel Hall",
      "Nurse Tina Allen",
      "Nurse Victor Baker",
      "Nurse Wendy Nelson",
    ],
    Maternity: [
      "Nurse Xavier Perez",
      "Nurse Yolanda Roberts",
      "Nurse Zoe Campbell",
      "Nurse Aaron Phillips",
      "Nurse Bethany Parker",
      "Nurse Chris Turner",
    ],
  };
  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  }; const [savedData, setSavedData] = useState(null);
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState('form');
  const [dataLoaded, setDataLoaded] = useState(false);
  // Auto-save functionality
  // Auto-save functionality - only after initial data is loaded
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveFormData(formData);
        setShowSaveNotification(true);
        setTimeout(() => setShowSaveNotification(false), 2000);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded]);

  // Save form data to sessionStorage
  const saveFormData = (data) => {
    sessionStorage.setItem(`PRE_ANAESTHEForm_${uhid_no}`, JSON.stringify(data));
    console.log('Form data saved:', data);
  };

  // Get saved form data
  const getSavedFormData = () => {
    const saved = sessionStorage.getItem(`PRE_ANAESTHEForm_${uhid_no}`);
    return saved ? JSON.parse(saved) : null;
  };
  useEffect(() => {
    const saved = getSavedFormData();
    if (saved && Object.keys(saved).length > 0) {
      setSavedData(saved);
      setFormData(saved);
    }
  }, []);
  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : subValue
        );
      }
      return value === true;
    });
  };

  // Clear saved data - ONLY called on successful submit
  const clearSavedData = () => {
    setSavedData(null);
    sessionStorage.removeItem(`PRE_ANAESTHEForm_${uhid_no}`);
    sessionStorage.removeItem(`formStatus_PRE_ANAESTHE_${uhid_no}`);
  };

  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      saveFormData(formData);
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_PRE_ANAESTHE_${uhid_no}`, JSON.stringify({
        formName: 'PRE-ANAESTHETIC EVALUATION',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/preAnaestheticForm/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  const handleBack = () => {
    if (next !== '') {
      setNext('');
    } else {
      navigate(-1); // Navigate to the previous page
    }
  };

  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_pre_anaesthetic_api_share_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/preAnaestheticForm/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,\n\nPlease fill the post-operative analgesia chart:\n\n${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // no spaces or special chars for wa.me
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };
  const handleNextClick = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (formData.proposed_date_time === '') {
      showNotification('error', 'Please select a proposed date and time before continuing.');
    } else {
      setNext('next');
    }
  };
  return (
    next === '' ?
      <ThemeProvider theme={theme}>
        <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
          <Paper elevation={3} sx={{ padding: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
              {/* Heading with Icon */}
              <Typography
                variant="h4"
                sx={{
                  color: '#008080',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  letterSpacing: 0.5,
                }}
              >
                PRE-ANAESTHETIC EVALUATION
              </Typography>

              {/* Right-aligned Logo and Text */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img src="/logo.png" alt="Logo" className="w-8 h-8" />
                <Typography
                  variant="h6"
                  sx={{
                    color: '#008080',
                    marginLeft: 1,
                    fontWeight: 500,
                    letterSpacing: 0.3,
                  }}
                >
                  OTMS
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
              {/* Left-aligned Back Button */}
              <Button
                variant="outlined"
                onClick={handleBack}
                sx={{ marginLeft: 2 }}
              >
                Back
              </Button>

              {/* Right-aligned Buttons */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  onClick={handleHomeNavigation}
                  sx={{ marginRight: 1 }}
                >
                  Home
                </Button>
                <Button
                  variant="contained"
                  onClick={() => goToVideoRecorder("PRE-ANAESTHETIC EVALUATION", uhid_no)}
                  sx={{ marginRight: 1 }}
                >
                  Add Iterative Video
                </Button>
                <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                  <ShareIcon />
                </IconButton>
              </Box>
            </Box>
            <br></br>
            <Divider sx={{ mb: 2 }} />
            <form >
              {/* Patient Info */}
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField fullWidth InputProps={{ readOnly: true, }} label="Name" value={formData.name} required onChange={handleNameChange} name="name" />
                </Grid>
                <Grid item xs={6}>
                  <TextField InputProps={{ readOnly: true, }} fullWidth label="Age" value={formData.age} required onChange={handleChange("age")} type="number" />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Sex"
                    value={formData.sex}
                    InputProps={{ readOnly: true, }}
                    onChange={handleChange("sex")}
                    required
                    select
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    freeSolo
                    options={opOptions.map(String)} // Convert numbers to strings because Autocomplete expects strings
                    value={formData.op_no || ''}
                    onInputChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        op_no: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Op"
                        type="number"
                        fullWidth
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label=" IP No" InputProps={{ readOnly: true, }} value={formData.ip_no} onChange={handleChange("ip_no")} required type="number" />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label="UHID No" value={formData.uhid_no} onChange={handleChange("uhid_no")} required InputProps={{ readOnly: true, }} type="number" />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    freeSolo
                    options={diagnosisOptions}
                    value={formData.pre_op_diagnosis || ''}
                    onInputChange={(event, newValue) => {
                      setFormData(prev => ({
                        ...prev,
                        pre_op_diagnosis: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<span>Pre-Op Diagnosis <span style={{ color: 'red' }}>*</span></span>}
                        fullWidth
                        variant="outlined"
                        name="pre_op_diagnosis"
                        error={!!errors.pre_op_diagnosis}
                        helperText={errors.pre_op_diagnosis}
                        onBlur={handleBlur}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Autocomplete
                    freeSolo
                    options={procedureOptions}
                    value={formData.proposed_procedure || ''}
                    onInputChange={(event, newValue) => {
                      setFormData(prev => ({
                        ...prev,
                        proposed_procedure: newValue,
                      }));
                      if (errors.proposed_procedure) setErrors(prev => ({ ...prev, proposed_procedure: '' }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<span>Proposed Procedure <span style={{ color: 'red' }}>*</span></span>}
                        fullWidth
                        variant="outlined"
                        name="proposed_procedure"
                        error={!!errors.proposed_procedure}
                        helperText={errors.proposed_procedure}
                        onBlur={handleBlur}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography>Date & Time <span style={{ color: 'red' }}>*</span></Typography>
                  <TextField
                    type="DateTime-local"
                    inputProps={{
                      min: new Date().toISOString().slice(0, 16),
                    }}
                    fullWidth
                    value={formData.proposed_date_time}
                    required
                    onChange={handleChange("proposed_date_time")}
                    name="proposed_date_time"
                    error={!!errors.proposed_date_time}
                    helperText={errors.proposed_date_time}
                    onBlur={handleBlur}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              {/* Medical Illness */}
              <Typography variant="h6">Medical Illness</Typography>
              <h5>CVS</h5>
              {illnessMapping.cvs.map((illness, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={formData[illness.key]}
                      onChange={handleChange(illness.key)}
                    />
                  }
                  label={illness.name}
                />
              ))}
              <TextField label="Others" fullWidth value={formData.cvs_others} onChange={handleChange("cvs_others")} />

              <Divider sx={{ my: 2 }} />

              <h5>RS</h5>
              {illnessMapping.rs.map((illness, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={formData[illness.key]}
                      onChange={handleChange(illness.key)}
                    />
                  }
                  label={illness.name}
                />
              ))}
              <TextField label="Others" fullWidth value={formData.rs_others} onChange={handleChange("rs_others")} />

              <Divider sx={{ my: 2 }} />

              <h5>GIT</h5>
              {illnessMapping.git.map((illness, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={formData[illness.key]}
                      onChange={handleChange(illness.key)}
                    />
                  }
                  label={illness.name}
                />
              ))}
              <TextField label="Others" fullWidth value={formData.git_others} onChange={handleChange("git_others")} />

              <Divider sx={{ my: 2 }} />

              <h5>GNS</h5>
              {illnessMapping.gns.map((illness, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={formData[illness.key]}
                      onChange={handleChange(illness.key)}
                    />
                  }
                  label={illness.name}
                />
              ))}
              <Divider sx={{ my: 2 }} />
              <Typography>Spine</Typography>
              <Autocomplete
                freeSolo
                options={spineOptions}
                value={formData.spine || ''}
                onInputChange={(event, newValue) => {
                  setFormData(prev => ({
                    ...prev,
                    spine: newValue,
                  }));
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Spine" fullWidth variant="outlined" />
                )}
              />
              <Divider sx={{ my: 2 }} />

              <h5>ENDOCRINE:</h5>
              <FormControlLabel
                control={<Checkbox checked={formData.endocrine_dm} onChange={handleChange("endocrine_dm")} />}
                label="Diabetes Mellitus"
              />
              <TextField
                fullWidth
                label="Thyroid"
                value={formData.endocrine_thyroid}
                onChange={handleChange("endocrine_thyroid")}
                select
              >
                <MenuItem value="Hypo">Hypo</MenuItem>
                <MenuItem value="Hyper">Hyper</MenuItem>
              </TextField>
              <br></br>
              <br></br>
              <TextField fullWidth label="Others" value={formData.endocrine_others} onChange={handleChange("endocrine_others")} />

              <Divider sx={{ my: 2 }} />

              <h5>GU SYSTEM</h5>
              <FormControlLabel
                control={<Checkbox checked={formData.gu_system_burns} onChange={handleChange("gu_system_burns")} />}
                label="Burns"
              />

              <br></br>
              <br></br>
              <TextField fullWidth label="Others" value={formData.gu_system_others} onChange={handleChange("gu_system_others")} />

              <Divider sx={{ my: 2 }} />
              <Typography variant="h5" justifyContent={"center"}>Past/Current Medications</Typography>
              <TextField fullWidth label="PAST/CURRENT MEDICATIONS" value={formData.past_or_current_medications} onChange={handleChange("past_or_current_medications")} multiline rows={3} />
              <Divider sx={{ my: 2 }} />

              {/* Personal History */}
              <Typography variant="h6">PAST HISTORY</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={1}>
                  <Checkbox checked={formData.previous_hospitalization} onChange={handleChange("previous_hospitalization")} /> Previous Hospitalization
                </Grid>
                <Grid item xs={6} sx={1}>
                  <Checkbox checked={formData.previous_surgery_anesthesia} onChange={handleChange("previous_surgery_anesthesia")} /> Previous Surgery
                </Grid>
                <Grid item xs={6} sx={1}>
                  <Checkbox checked={formData.drug_allergy} onChange={handleChange("drug_allergy")} /> Drug Allergy
                </Grid>



              </Grid>

              <Divider sx={{ my: 2 }} />
              <Divider sx={{ my: 2 }} />

              {/* Personal History */}
              <Typography variant="h6">PERSONAL HISTORY</Typography>
              <Grid container spacing={2}>
                <Grid item xs={3} sx={1}>
                  <Checkbox checked={formData.smoking} onChange={handleChange("smoking")} /> Smoking
                </Grid>
                <Grid item xs={3} sx={1}>
                  <Checkbox checked={formData.substance_abuse} onChange={handleChange("substance_abuse")} /> Substance Abuse
                </Grid>
                <Grid item xs={3} sx={1}>
                  <Checkbox checked={formData.alcoholism} onChange={handleChange("alcoholism")} /> Alcohollem
                </Grid>
                <Grid item xs={3} sx={1}>
                  <Checkbox checked={formData.pregnancy_lactation} onChange={handleChange("pregnancy_lactation")} /> Preg/Lact
                </Grid>
                <Grid item xs={6} sx={1}>
                  <TextField value={formData.breath_holding_time} onChange={handleChange("breath_holding_time")} label="Breath Holding Time" variant="outlined" fullWidth type="time" InputLabelProps={{ shrink: true }} />
                </Grid>
                <Grid item xs={6} sx={1}>
                  <Autocomplete
                    freeSolo
                    options={effortToleranceOptions}
                    value={formData.effort_tolerance || ''}
                    onInputChange={(event, newValue) => {
                      setFormData(prev => ({
                        ...prev,
                        effort_tolerance: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Effort Tolerance"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField value={formData.personal_history_others} onChange={handleChange("personal_history_others")} label="Others" variant="outlined" fullWidth />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />


              <Typography variant="h6">Airway Assessment</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField select fullWidth label="MPC" value={formData.mpc} onChange={handleChange("mpc")} name="mpc">
                    {['I', 'II', 'III', 'IV'].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField select fullWidth label="MO" value={formData.mo} onChange={handleChange("mo")}>
                    {['<2FB', '>2FB'].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={6}>
                  <TextField select fullWidth label="Neck Movement" value={formData.neck_movement} onChange={handleChange("neck_movement")}>
                    {['N', "Restricted"].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField select fullWidth label="Mento-Hype distance" value={formData.mento_hyoid_distance} onChange={handleChange("mento_hyoid_distance")}>
                    {[">4cm", "<4cm"].map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    freeSolo
                    options={dentitionOptions}
                    value={formData.dentition || ''}
                    onInputChange={(event, newValue) => {
                      setFormData(prev => ({
                        ...prev,
                        dentition: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Dentition"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label="Others" value={formData.airway_assessment_others} onChange={handleChange("airway_assessment_others")} />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              <Typography variant="h6">Vital Signs</Typography>
              <Grid container spacing={2}>
                {["pr", "bp", "spo2", "temp", "ht", "wt"].map((key) => (
                  <Grid item xs={6} key={key}>
                    <Autocomplete
                      freeSolo
                      options={options[key]}
                      value={formData[key] || ''}
                      onInputChange={(event, newInputValue) => {
                        setFormData(prev => ({
                          ...prev,
                          [key]: newInputValue,
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={key.toUpperCase()}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {params.InputProps.endAdornment}
                                <span style={{ marginLeft: 4 }}>
                                  {key === 'bp' ? 'mmHg' : key === 'spo2' ? '%' : key === 'temp' ? '°F' : key === 'ht' ? 'cm' : 'kg'}
                                </span>
                              </>
                            ),
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                ))}
              </Grid>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">Risk Factors / Concerns</Typography>
              <TextField fullWidth label="Risk Factors / Concerns" value={formData.riskfactors_concerns} onChange={handleChange("riskfactors_concerns")} multiline rows={3} />

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6">General Examination</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.conscious} onChange={handleChange("conscious")} />}
                    label="Consious"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.oriented} onChange={handleChange("oriented")} />}
                    label="Oriented"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.pallor} onChange={handleChange("pallor")} />}
                    label="Pallor"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.febrile} onChange={handleChange("febrile")} />}
                    label="Febrile"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.icterus} onChange={handleChange("icterus")} />}
                    label="Icterus"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.cyanosis} onChange={handleChange("cyanosis")} />}
                    label="Cyanosis"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.clubbing} onChange={handleChange("clubbing")} />}
                    label="Clubbing"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.oedema} onChange={handleChange("oedema")} />}
                    label="Oedema"
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />
              <TextField fullWidth label="Others" value={formData.general_examination_others} onChange={handleChange("general_examination_others")} multiline rows={3} />

              <Divider sx={{ my: 2 }} />
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
                  <DraftSaveButton
                    formData={formData}
                    formKey={DRAFT_KEYS.PRE_ANAESTHETIC_FORM}
                    uhidNo={uhid_no}
                    onDraftLoaded={(draftData) => setFormData(prev => ({ ...prev, ...draftData }))}
                  />
                  <Button type="button" variant="contained" color="primary" sx={{ marginTop: 3 }} fullWidth onClick={handleNextClick}>
                    Next
                  </Button>
                </Box>
              </Grid>
            </form>
          </Paper>
        </Container>
      </ThemeProvider>

/*     export default PreAnaestheticForm1;
 */    :
      <ThemeProvider theme={theme}>
        <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
          <Paper elevation={3} sx={{ padding: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
              {/* Heading with Icon */}
              <Typography
                variant="h4"
                sx={{
                  color: '#008080',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  letterSpacing: 0.5,
                }}
              >
                PRE-ANAESTHETIC EVALUATION
              </Typography>

              {/* Right-aligned Logo and Text */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img src="/logo.png" alt="Logo" className="w-8 h-8" />
                <Typography
                  variant="h6"
                  sx={{
                    color: '#008080',
                    marginLeft: 1,
                    fontWeight: 500,
                    letterSpacing: 0.3,
                  }}
                >
                  OTMS
                </Typography>
              </Box>
            </Box>

            {/* Section: Medical Evaluation */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={cvsOptions}
                  value={formData.cvs || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, cvs: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="CVS" variant="outlined" fullWidth name="cvs" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={rsOptions}
                  value={formData.rs || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, rs: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="RS" variant="outlined" fullWidth name="rs" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={gitOptions}
                  value={formData.git || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, git: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="GIT" variant="outlined" fullWidth name="git" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={gnsOptions}
                  value={formData.gns || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, gns: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="GNS" variant="outlined" fullWidth name="gns" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={spineOptions}
                  value={formData.spine || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, spine: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Spine" variant="outlined" fullWidth name="spine" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={expertOpinionOptions}
                  value={formData.expert_opinion || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData(prev => ({ ...prev, expert_opinion: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Expert(s) Opinion" variant="outlined" fullWidth name="expert_opinion" />
                  )}
                />
              </Grid>
              <Grid item xs={12} >
                <TextField fullWidth label="Others" variant="outlined" onChange={handleChange("others")} value={formData.others} name="others" />
              </Grid>
            </Grid>

            {/* Section: Investigations */}
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              Investigation
            </Typography>
            <Grid container spacing={2}>
              {fields[0].key1.map((key, index) => (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Autocomplete
                    freeSolo
                    options={investigationOptions[key] || []}
                    value={formData[key] || ''}
                    onInputChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        [key]: newValue || '',
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={fields[0].name[index]}
                        variant="outlined"
                        fullWidth
                        name={key}
                      />
                    )}
                  />

                </Grid>
              ))}
              <Grid item xs={12}>
                <TextField fullWidth label="Others(if any)" variant="outlined" onChange={handleChange("other_investigations")} value={formData.other_investigations} name="other_investigations" />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            {/* Section: Anaesthesia ASA Grade */}
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              PROV FIT ANAESTHESIA ASA GRADE
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="asa_grade"
                value={formData.asa_grade || ''}
                onChange={handleChange("asa_grade")}
              >
                {[1, 2, 3, 4, 5, "E"].map((grade) => (
                  <FormControlLabel
                    key={grade}
                    control={<Radio />}
                    label={grade}
                    value={String(grade)}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              PLAN OF ANAESTHESIA
            </Typography>
            <br></br>
            <Autocomplete
              freeSolo
              options={planOptions}
              value={formData.plan_of_anesthesia || ""}
              onInputChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  plan_of_anesthesia: newValue,
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="PLAN OF ANAESTHESIA"
                  variant="outlined"
                  fullWidth
                  name="plan_of_anesthesia"
                />
              )}
            />
            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={preOpInstructionsOptions}
                  value={formData.pre_op_instructions || ""}
                  onInputChange={(event, newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      pre_op_instructions: newValue,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pre-Op Instructions"
                      variant="outlined"
                      fullWidth
                      name="pre_op_instructions"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>

                <TextField fullWidth label="Day of Surgery - Medications" type="date" variant="outlined" InputLabelProps={{ shrink: true }}
                  onChange={handleChange("day_of_surgery_medications")} value={formData.day_of_surgery_medications} name="day_of_surgery_medications" inputProps={{
                    min: new Date().toISOString().split("T")[0], // optional: prevent past dates
                  }} />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={instructionsOptions}
                  value={formData.instructions || ""}
                  onInputChange={(event, newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      instructions: newValue,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="INSTRUCTIONS"
                      variant="outlined"
                      fullWidth
                      name="instructions"
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            {/* Section: Informed Consent */}
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              Informed Consent
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup>
                {["Standard Risk", "Intermediate Risk", "High Risk"].map((risk) => (
                  <FormControlLabel key={risk} value={risk} control={<Radio />} label={risk} onChange={handleChange("informed_consent")} name="informed_consent" checked={formData.informed_consent === risk} />
                ))}
              </RadioGroup>
            </FormControl>
            <Divider sx={{ my: 2 }} />
            {/* Section: Additional Orders */}
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              Additional Orders
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={npoOrdersOptions}
                  value={formData.npo_orders || ""}
                  onInputChange={(event, newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      npo_orders: newValue,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="NPO Orders"
                      variant="outlined"
                      fullWidth
                      name="npo_orders"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Blood Products (Arrange/Reserve)"
                  value={formData.blood_products}
                  onChange={handleChange('blood_products')}
                  variant="outlined"
                >
                  <MenuItem value="Arrange">Arrange</MenuItem>
                  <MenuItem value="Reserve">Reserve</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={reAssessmentOptions}
                  value={formData.re_assessment || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      re_assessment: newInputValue,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="RE-ASSESSMENT"
                      variant="outlined"
                      fullWidth
                      name="re_assessment"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={investigationsOptions}
                  value={formData.investigations || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      investigations: newInputValue,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="INVESTIGATIONS"
                      variant="outlined"
                      fullWidth
                      name="investigations"
                    />
                  )}
                />
              </Grid>
            </Grid>

            {/* Section: Signature */}
            <Typography variant="h6" sx={{ marginTop: 3 }}>
              Signatures
            </Typography>

            <Grid container spacing={2}>
              {[
                {
                  label: "Anaesthetist",
                  key: "anaesthesiologist_signature",
                  key1: "anaesthesiologist_name",
                  key2: "anaesthesiologist_date",
                  key3: "anaesthesiologist_time",
                  group: "AnaesthesiaSpecialists",
                  type: "doctor"
                },
                {
                  label: "Surgeon",
                  key: "surgeon_signature",
                  key1: "surgeon_name",
                  key2: "surgeon_date",
                  key3: "surgeon_time",
                  group: "Orthopedics", // or Cardiologists, etc.
                  type: "doctor"
                },
                {
                  label: "Nurse",
                  key: "nurse_signature",
                  key1: "nurse_name",
                  key2: "nurse_date",
                  key3: "nurse_time",
                  group: "Surgery", // or ICU, Pediatrics, etc.
                  type: "nurse"
                }
              ].map((person, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <FormControl fullWidth sx={{ marginTop: 1 }} error={!!errors[person.key1]}>
                    <InputLabel id={`${person.key1}-label`}>
                      <span>Name ({person.label}) <span style={{ color: 'red' }}>*</span></span>
                    </InputLabel>
                    <Select
                      labelId={`${person.key1}-label`}
                      name={person.key1}
                      value={formData[person.key1]}
                      label={<span>Name ({person.label}) <span style={{ color: 'red' }}>*</span></span>}
                      onChange={handleNameChange}
                      onBlur={handleBlur}
                      error={!!errors[person.key1]}
                    >
                      <MenuItem value="">
                        <em>Select {person.label}</em>
                      </MenuItem>

                      {person.type === "doctor" &&
                        doctorGroups[person.group]?.map((doctor, idx) => (
                          <MenuItem key={idx} value={doctor}>
                            {doctor}
                          </MenuItem>
                        ))}

                      {person.type === "nurse" &&
                        nurseGroups[person.group]?.map((nurse, idx) => (
                          <MenuItem key={idx} value={nurse}>
                            {nurse}
                          </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText error>{errors[person.key1] || ' '}</FormHelperText>
                  </FormControl>
                  <TextField
                    name={person.key2}
                    value={formData[person.key2]}
                    fullWidth
                    label={`Signature Date (${person.label})`}
                    variant="outlined"
                    sx={{ marginTop: 1 }}
                    type="date"
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />

                  <TextField
                    name={person.key3}
                    value={formData[person.key3]}
                    fullWidth
                    label={`Signature Time (${person.label})`}
                    variant="outlined"
                    sx={{ marginTop: 1 }}
                    type="time"
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />

                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{ marginTop: 2 }}
                    onClick={() => handleSignatureOpen(person.key)}
                  >
                    Sign Here
                  </Button>

                  {formData[person.key] && (
                    <img
                      src={`data:image/png;base64,${formData[person.key]}`}
                      alt="Signature"
                      style={{
                        marginTop: 10,
                        border: "1px solid black",
                        width: "100%",
                        height: "150px"
                      }}
                    />
                  )}
                </Grid>
              ))}
            </Grid>


            <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
              <DialogTitle>Provide Your Signature</DialogTitle>
              <DialogContent>
                <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: "sigCanvas" }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSignatureClear} color="secondary">
                  Clear
                </Button>
                <Button onClick={handleSignatureSave} color="primary">
                  Done
                </Button>
              </DialogActions>
            </Dialog>

            <Divider sx={{ my: 2 }} />
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
                <DraftSaveButton
                  formData={formData}
                  formKey={DRAFT_KEYS.PRE_ANAESTHETIC_FORM}
                  uhidNo={uhid_no}
                  isUpdate={success === "success"}
                  onDraftLoaded={(draftData) => setFormData(prev => ({ ...prev, ...draftData }))}
                />
                <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 3 }} fullWidth onClick={handleSubmit}>
                  {success == "success" ? 'Update ' : 'Submit'}
                </Button>
              </Box></Grid>
          </Paper>
        </Container>
      </ThemeProvider>


  );
};

export default PreAnaestheticForm;  
